import { Icons } from "@/components/icons"

export const getStatusStyle = (status: string, percentage: number | null) => {
  if (status === "New" || percentage === null) {
    return { color: "text-gray-500", bgColor: "bg-transparent", icon: null }
  }
  if (status === "Flat") {
    return {
      color: "text-blue-500",
      bgColor: "bg-blue-100 dark:bg-blue-900",
      icon: <Icons.minus className="text-blue-500" />,
    }
  }
  if (status === "Decreased") {
    return {
      color: "text-red-500",
      bgColor: "bg-red-100 dark:bg-red-900",
      icon: <Icons.mixer className="important text-red-500" />,
    }
  }
  return {
    color: "text-green-500",
    bgColor: "bg-green-100 dark:bg-green-900",
    icon: <Icons.rightArrow />,
  }
}
